import React, { useContext, useMemo } from 'react'
import { LeagueContext } from '../../../../Context'
import { CardSwiper } from '../../../CardSwiper'
import { CategoryView } from './CategoryView'
import { Box } from '../../../Layout'
import { Head2 } from 'Components/Typography/Text.styles'

export const VideoCategories: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { homeFeed } = useContext(LeagueContext)!

  const categories = useMemo(() => {
    return homeFeed?.categories || []
  }, [homeFeed])

  const items = useMemo(() => {
    return categories.map((category) => (
      <CategoryView key={category.tags} category={category} />
    ))
  }, [categories])
  if (!homeFeed?.categories?.length) return null

  return (
    <Box>
      <Head2>{'Stories'}</Head2>
      <CardSwiper items={items} cardSize="videoCategories" />
    </Box>
  )
}
